module.exports = __webpack_public_path__ + "img/cashback2.1ed9ac38.png";